<template>
  <div class="top-section">
    <div class="plan-date">
      <label>{{ __("Date") }}</label>
      <div>
        <i-customized-calendar
          :boxed="true"
          class="p-inputtext--alt"
          v-model="planDate"
          @date-select="getData(null)"
        />
        <i-form-error :data="errors.planDate" />
      </div>
      <p-vue-dropdown
        :options="orderOptions"
        :optionLabel="'label'"
        :optionValue="'value'"
        :placeholder="__('sort')"
        v-model="order"
        scrollHeight="310px"
        class="dropdown"
        @change="sortServiceCalls"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
    </div>

    <div class="plan-date comment">
      <label>{{ __("Comment") }}</label>
      <div>
        <p-vue-textarea
          :autoResize="true"
          rows="2"
          class="p-inputtext--alt"
          v-model="comment"
          @blur="saveProblem(null, false)"
        />
      </div>
    </div>
    <div class="types">
      <div>
        <p-vue-radio
          id="my-problems"
          name="problems"
          value="0"
          v-model="typeFilter"
          @change="getData"
        />
        <label class="label" for="my-problems">{{ __("My calls") }}</label>
      </div>
      <div>
        <p-vue-radio
          id="all-problems"
          name="problems"
          value="1"
          v-model="typeFilter"
          @change="getData(null)"
        />
        <label class="label" for="all-problems">{{
          __("Everyone's readings")
        }}</label>
      </div>
    </div>
    <div class="types">
      <div>
        <p-vue-checkbox
          v-model="showPlannedProblems"
          :binary="true"
          @change="getData(null)"
          id="showPlannedProblems"
        />
        <label class="label" for="showPlannedProblems">{{
          __("View scheduled readings")
        }}</label>
      </div>
    </div>
  </div>

  <div class="buildings">
    <div
      class="building"
      v-for="(building, index) in buildingsProblems"
      :key="index"
    >
      <div class="title" @click.self="building.Collapsed = !building.Collapsed">
        <div class="p-d-flex">
          <div class="p-checkbox p-component">
            <div
              class="p-checkbox-box"
              :class="{ 'p-highlight': building.selected }"
              role="checkbox"
              :aria-checked="building.selected"
              @click="selectBuilding(building)"
            >
              <i
                class="pi pi-minus"
                v-if="building.anySelected && !building.selected"
              ></i>
              <i class="pi pi-check" v-if="building.selected"></i>
            </div>
          </div>

          <div class="p-mx-2" @click="building.Collapsed = !building.Collapsed">
            <span>{{ __(building.Address) }}</span>
            <span class="problems-count">{{
              " (" + building.problems.length + ") "
            }}</span>
          </div>
        </div>
        <i
          v-if="!building.Collapsed"
          class="pi pi-chevron-down p-ml-2"
          @click="building.Collapsed = !building.Collapsed"
        ></i>
        <i
          v-if="building.Collapsed"
          class="pi pi-chevron-up p-ml-2"
          @click="building.Collapsed = !building.Collapsed"
        ></i>
      </div>
      <div class="problems" v-show="building.Collapsed">
        <div
          class="problem"
          v-for="(problem, index) in building.problems"
          :key="index"
        >
          <p-vue-checkbox
            v-model="problem.selected"
            :binary="true"
            @change="selectProblem(problem, building)"
          />

          <div class="data">
            <div class="p-d-flex p-jc-between">
              <span class="subject">{{ problem.Subject }}</span>

              <span
                class="serviceCall-status"
                :class="{
                  inTreatment: problem.lastUpdateDesc,
                  awaitingTreatment: !problem.lastUpdateDesc,
                  closing: problem.ClosingDate,
                }"
                @click="showChangeStatusDialog(problem)"
              >
                {{ __(problem.Tupal) }}
              </span>
              <!-- <span @click="showChangeStatusDialog(problem)">{{
                __(problem.Tupal)
              }}</span> -->
            </div>
            <div class="problem-details">
              <div class="detail">
                <label>{{ __("Reading") }}: </label>
                <a
                  href="#"
                  class="reading"
                  @click.prevent="
                    () => {
                      previewHandle(problem);
                    }
                  "
                >
                  {{ problem.PID }}
                </a>
                <!-- <span>{{ problem.PID }}</span> -->
              </div>
              <div class="detail">
                <label>{{ __("Reading Date") }}: </label>
                <span>{{
                  problem.OpD
                    ? dateFormat(new Date(problem.OpD), false, false, true)
                    : ""
                }}</span>
              </div>
              <div class="detail">
                <label>{{ __("Due") }}: </label>
                <span>{{
                  problem.DDueDate
                    ? dateFormat(new Date(problem.DDueDate), false, false, true)
                    : ""
                }}</span>
              </div>
              <div class="detail">
                <label>{{ __("Last update") }}: </label>
                <span>{{
                  problem.LastUpdateDate
                    ? dateFormat(
                        new Date(problem.LastUpdateDate),
                        false,
                        false,
                        true
                      )
                    : ""
                }}</span>
              </div>
            </div>
            <div class="start-time">
              <label>{{ __("שעת ביקור") }}: </label>
              <i-customized-calendar
                inputId="time12"
                v-model="problem.StartTime"
                :timeOnly="true"
                hourFormat="24"
                @date-select="changeTimeToProblem(problem, building)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <i-override-dialog
    v-model:visible="previewModel"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :showClose="false"
    :dismissableMask="true"
    :title="`${__('Reading')} ${previewProblem?.PID}`"
  >
    <local-preview
      :serviceCallSelectedData="previewProblem"
      :close="() => (previewModel = false)"
      @reloadData="getData(previewProblem?.PID)"
    />
  </i-override-dialog>
  <local-service-call
    v-if="problemToChangeStatus"
    :serviceCall="problemToChangeStatus"
    :showServiceCall="false"
    @refreshServiceCall="refreshServiceCall"
  ></local-service-call>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import {
  arrayToCsv,
  dateFormat,
  sort_array_by_field,
} from "@/services/apointUtil";
import { getWorkerData } from "@/services/service";
import LocalPreview from "@/components/partials/p-service-calls-preview";
import { mapState } from "vuex";
import { errorReceived } from "@/services/apointUtil";
import LocalServiceCall from "../v-service-calls/service-call";
import { __ } from "@/plugins/i18n/";

export default {
  components: {
    LocalPreview,
    LocalServiceCall,
  },
  data() {
    return {
      buildingsProblems: [],
      allProblems: [],
      typeFilter: "0",
      planDate: null,
      errors: { planDate: null },
      showPlannedProblems: true,
      dateFormat,
      previewProblem: null,
      previewModel: false,
      comment: null,
      problemToChangeStatus: null,
      orderOptions: [
        {
          label: __("Opening date") + " - " + __("ascending order"),
          value: "OpD",
        },
        {
          label: __("Opening date") + " - " + __("descending order"),
          value: "OpD DESC",
        },
        {
          label: __("Problem ID") + " - " + __("ascending order"),
          value: "PID",
        },
        {
          label: __("Problem ID") + " - " + __("descending order"),
          value: "PID DESC",
        },
        {
          label: __("Priority - OpenDate") + " - " + __("descending order"),
          value: "Priority OpenDate DESC",
        },
        {
          label: __("Due Date") + " - " + __("ascending order"),
          value: "DDueDate",
        },
        {
          label: __("Due Date") + " - " + __("descending order"),
          value: "DDueDate DESC",
        },
      ],
      order: null,
    };
  },
  mounted() {
    this.planDate = new Date();
    this.$store.commit("api/setSessionData", {
      workerGUID: null,
    });
    if (!this.workerID || !this.workerGUID)
      getWorkerData().then(() => this.getData());
    else this.getData();
  },
  methods: {
    getData(pid) {
      this.selectedKeys = [];
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserGuid", this.workerGUID, apiPType.Int),
        apiParam("TypeFilter", this.typeFilter, apiPType.TinyInt),
        apiParam("showPlanned", this.showPlannedProblems, apiPType.Bit),
        apiParam("datePlanned", this.planDate, apiPType.DateTime),
      ];
      callProc("WorkerApp_GetListProblemsToDailyPlan", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          /*
            בקריאה זו חוזרות 4 טבלאות:
            Table - קריאות שירות
            Table1 - תמונות
            Table2 - עדכונים
            Table3 - תמונות לעדכונים
            Table4 - הערות לפי תאריך
          */
          result.Table2.forEach((update) => {
            update.Images = result.Table3.filter(
              (f) => f.updateID == update.Num
            );
          });
          if (pid) {
            // this.previewModel = false;
            let index = this.allProblems.findIndex((f) => f.PID == pid);
            if (
              this.allProblems[index] &&
              this.allProblems[index].Tupal != "טופל"
            ) {
              if (this.allProblems[index].StartTime)
                this.allProblems[index].StartTime = new Date(
                  this.allProblems[index].StartTime
                );

              this.allProblems[index].selected =
                this.allProblems[index].PDID != null;

              this.allProblems[index].Images = result.Table1.filter(
                (f) => f.PID == pid
              );

              this.allProblems[index].Updates = result.Table2.filter(
                (f) => f.PID == pid
              );
            }
            this.previewHandle(this.allProblems[index]);
            this.$store.dispatch("doLoading", false);
          } else {
            this.$store.dispatch("doLoading", false);
            this.buildingsProblems = [];
            this.allProblems = result.Table;
            this.allProblems.forEach((element) => {
              if (!this.buildingsProblems.find((f) => f.BID == element.BID))
                this.buildingsProblems.push({
                  BID: element.BID,
                  Address: element.BuildingName,
                  Collapsed: false,
                });
              if (element.StartTime)
                element.StartTime = new Date(element.StartTime);
              element.selected = element.PDID != null;
              element.Images = result.Table1.filter(
                (f) => f.PID == element.PID
              );
              element.Updates = result.Table2.filter(
                (f) => f.PID == element.PID
              );
            });
            this.sortServiceCalls();
            // this.buildingsProblems.forEach((element) => {
            //   element.problems = this.allProblems.filter(
            //     (f) => f.BID == element.BID
            //   );
            //   this.setBuildingSelectesOrAnySelected(element);
            // });

            this.comment = result.Table4[0]?.Comment;
            // console.log(this.buildingsProblems);
          }
        })
        .catch((e) => {
          errorReceived("WorkerApp_GetListProblemsToDailyPlan", e);
        });
    },
    getCsvPID(building) {
      let pid = [];
      building.problems.forEach((f) => {
        if (f.selected != building.selected) pid.push(f.PID);
      });
      return arrayToCsv(pid);
    },
    saveProblem(csvPID, selected, problem = null) {
      let procParams = [
        apiParam("CSVPID", csvPID, apiPType.NVarChar),
        apiParam("WorkerID", this.workerID, apiPType.Int),
        apiParam("PlanDate", this.planDate, apiPType.DateTime),
        apiParam("Selected", selected, apiPType.Bit),
        apiParam(
          "StartTime",
          problem ? problem.StartTime : null,
          apiPType.DateTime
        ),
        apiParam("Comment", this.comment, apiPType.NVarChar),
      ];
      callProc("WorkerApp_AddOrUpdateDailyPlan", procParams).catch(() => {
        errorReceived("WorkerApp_AddOrUpdateDailyPlan");
      });
    },
    selectBuilding(building) {
      building.selected = !building.selected;
      building.anySelected = false;
      this.saveProblem(this.getCsvPID(building), building.selected);
      building.problems.forEach(
        (problem) => (problem.selected = building.selected)
      );
    },
    selectProblem(problem, building) {
      this.setBuildingSelectesOrAnySelected(building);
      this.saveProblem(problem.PID, problem.selected, problem);
    },
    changeTimeToProblem(problem, building) {
      problem.selected = true;
      this.selectProblem(problem, building);
    },
    setBuildingSelectesOrAnySelected(building) {
      let childrenSelectedCount = building.problems.filter((f) => f.selected)
        .length;
      if (childrenSelectedCount == building.problems.length)
        building.selected = true;
      else {
        building.selected = false;
        if (childrenSelectedCount > 0) building.anySelected = true;
        else building.anySelected = false;
      }
    },
    previewHandle(problem) {
      this.previewProblem = problem;
      this.previewModel = true;
    },
    showChangeStatusDialog(problem) {
      this.problemToChangeStatus = problem;
    },
    refreshServiceCall(serviceCall) {
      this.problemToChangeStatus.Tupal = serviceCall.statusDesc;
      this.problemToChangeStatus.ClosingDate = serviceCall.ClosingDate;
      this.problemToChangeStatus.LastUpdateDate = serviceCall.LastDateUpdate;
      this.problemToChangeStatus = null;
    },
    sortServiceCalls() {
      if (!this.order) {
        if (this.serviceCallsOrder) this.order = this.serviceCallsOrder;
        else this.order = "DueDate";
      }
      this.$store.commit("api/setSessionData", {
        serviceCallsOrder: this.order,
      });
      
      let DESC = this.order.includes("DESC");
      switch (this.order) {
        case "OpD":
        case "OpD DESC":
        case "DDueDate":
        case "DDueDate DESC":
          sort_array_by_field(
            this.allProblems,
            this.order.replace(" DESC", ""),
            DESC,
            (a) => new Date(a)
          );
          break;
        case "PID":
        case "PID DESC":
          sort_array_by_field(this.allProblems, "PID", DESC, (a) =>
            parseInt(a)
          );
          break;
        case "Priority OpenDate DESC":
          this.allProblems.sort((a, b) => {
            if (a.BoldReportPriority === b.BoldReportPriority) {
              return new Date(a.OpenDate) < new Date(b.OpenDate) ? 1 : -1;
            } else {
              return a.BoldReportPriority < b.BoldReportPriority ? 1 : -1;
            }
          });
          break;
      }

      this.buildingsProblems.forEach((element) => {
        element.problems = this.allProblems.filter((f) => f.BID == element.BID);
        this.setBuildingSelectesOrAnySelected(element);
      });
    },
  },
  computed: {
    ...mapState({
      workerID: (state) => state.api.workerID,
      workerGUID: (state) => state.api.workerGUID,
      serviceCallsOrder: (state) => state.api.serviceCallsOrder,
    }),
  },
  watch: {
    workerID() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.building {
  font-weight: 600;
}

.problems-count {
  font-size: 12px;
  margin-right: 5px;
}

.plan-date,
.types {
  display: grid;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  color: var(--color-primary);
  font-size: 16px;
  grid-template-columns: 16% 39% 39%;
}

.plan-date.comment {
  grid-template-columns: 16% 81%;
}

.types {
  display: flex;
}

label {
  color: var(--color-primary);
}

.problem-details {
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 10px;
  gap: 10px;
}

.subject {
  font-weight: 600;
}

.top-section {
  padding: 0 25px;
}

.building {
  border: 1px solid #c8cacd;
  border-radius: 3px;
  margin: 5px;
}

.title {
  padding: 10px;
  display: flex;
  gap: 10px;
  background-color: #e8e8e8;
  justify-content: space-between;
}

.problem {
  padding: 10px 25px 10px 0;
  font-weight: 400;
  display: grid;
  grid-template-columns: 6% 85%;
  align-items: center;
  gap: 10px;
}

.problem:not(:last-child) {
  border-bottom: 1px solid #c8cacd;
}

.label {
  margin-right: 10px;
}

.detail {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 5px;
}

.p-highlight {
  color: #ffffff;
}

.reading {
  color: inherit;
}

.p-inputtextarea {
  width: 100%;
}

.start-time {
  display: grid;
  grid-template-columns: 30% 60%;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.inTreatment {
  color: #d39603;
}

.awaitingTreatment {
  color: #b90000;
}

.closing {
  color: var(--color-success);
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

@media screen and (max-width: 960px) {
  .p-orderlist {
    flex-direction: row !important;
  }
  .p-orderlist:deep(.p-orderlist-controls) {
    flex-direction: column !important;
  }
  .p-orderlist:deep(.p-orderlist-controls .p-button) {
    margin-right: 0 !important;
    margin-bottom: 0.5rem !important;
  }
}
</style>
